import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Playlists from '../containers/Playlists.js'
import {
  debug,
  getStatusString,
  formatTime,
  offsetLeft
} from '../Helpers.js'

export default class Controls extends Component {
  constructor (props) {
    super(props)

    this.startSetProgress = this.startSetProgress.bind(this)
    this.stopSetProgress = this.stopSetProgress.bind(this)
    this.setProgress = this.setProgress.bind(this)
    this.state = {
      displayPlaylist: false
    }
  }
  startSetProgress (evt) {
    this.props.scrubbingOn()
    this.setProgress(evt)
  }
  stopSetProgress (evt) {
    this.props.scrubbingOff()
    this.setProgress(evt)
  }
  setProgress (evt) {
    const progress = (evt.clientX - offsetLeft(this._progress_bar)) / this._progress_bar.clientWidth
    this.props.onSetCurrentTime(this.props.duration * progress)
  }
  renderLink (link) {
    if (link) {
      return (
        <span>[<a href={link}>link</a>]</span>
      )
    } else {
      return ''
    }
  }
  renderPlaylistTitle (artist, title, link) {
    let dom = ''
    if (artist) {
      dom = <span><span className='playlist-artist'>{artist} {this.renderLink(link)}</span> — <span className='playlist-title'>{title}</span></span>
    } else {
      dom = <span><span className='playlist-title'>{title}</span></span>
    }
    return (dom)
  }
  togglePlaylist () {
    this.setState({
      displayPlaylist: !this.state.displayPlaylist
    })
  }
  render () {
    const {
      playback,
      onPlayPause, onPlayNext, onPlayNextPlaylist, onMute,
      track, tracks,
      playlist, playlists,
      mute,
      className,
      mini,
      currentTime,
      duration,
      scrubbing
    } = this.props

    const status = getStatusString(playback)
    const next = playlists ? playlists.length && playlist + 1 < playlists.length ? playlists[playlist + 1] : playlists[0] : null
    const playbackIcon = playback === 1 ? 'fas fa-pause' : 'fas fa-play'
    const progress = currentTime / duration
    const muteIcon = mute ? 'fas fa-volume-off' : 'fas fa-volume-up'
    const nextIcon = 'fas fa-step-forward'
    const playlistIcon = 'fas fa-list-ul'
    const total = tracks && tracks.length ? tracks.length : 0

    let currentPlaylist = null
    let currentTrack = null

    if (playlists && playlists[playlist]) {
      currentPlaylist = [
        playlists[playlist].artist,
        playlists[playlist].title,
        playlists[playlist].link
      ]
    }
    if (tracks && tracks[track]) {
      currentTrack = [
        tracks[track].artist,
        tracks[track].title
      ]
    }

    return (
      <div className={className}>
        <div className='background'>
          {!mini &&
            <div className='trackinfo'>
              <div>Playlist: {currentPlaylist}</div>
              <div>Track: {currentTrack}</div>
              <br/>Current Track: <span className='value'>{track + 1} / {total}</span>
              Playback: <span className='value'>[{playback}: {status}]</span>
            </div>
          }
          {mini &&
            <div className='trackinfo' onClick={(e) => { this.togglePlaylist() }}>
              <div className='container'>
                {currentPlaylist &&
                  <span className='playlist'>
                    {this.renderPlaylistTitle(currentPlaylist[0], currentPlaylist[1], currentPlaylist[2])}
                  </span>
                }
                {currentTrack &&
                  <span className='track'>
                    {currentTrack[0] ? currentTrack[0] : '(Unknown artist)'} • {currentTrack[1] ? currentTrack[1] : '(untitled)'}
                  </span>
                }
              </div>
            </div>
          }
          <div className='playcontrol play'>
            <button aria-label='play / pause' onClick={onPlayPause}>
              <span className='icon'><i className={playbackIcon}></i></span>
            </button>
          </div>
          <div className='playcontrol next'>
            <button aria-label='next track' onClick={() => { if (track + 1 < total) { onPlayNext() } else { if (next) { onPlayNextPlaylist(next) } } } }><span className='icon'><i className={nextIcon}></i></span>
            </button>
          </div>
          <div className='playcontrol progress'>
            <div className='trackinfo current'>
              <span>{formatTime(currentTime < 0 ? 0 : currentTime)}</span>
            </div>
            { playback > 0 &&
              <div
                onMouseDown={(e) => { this.startSetProgress(e) }}
                onMouseMove={(e) => { if (scrubbing) { this.setProgress(e) } }}
                onMouseLeave={(e) => { if (scrubbing) { this.stopSetProgress(e) } }}
                onMouseUp={(e) => { this.stopSetProgress(e) }}
                ref={(ref) => { this._progress_bar = ref }}
                className="playcontrol time"
              >
                <div style={{ width: (progress * 100) + '%' }} className="bar"></div>
              </div>
            }
            { playback <= 0 &&
              <div ref={(ref) => { this._progress_bar = ref }} className="playcontrol time">
                <div style={{ width: (progress * 100) + '%' }} className="bar">
                </div>
              </div>
            }
            <div className='trackinfo duration'>
              <span>{formatTime(duration)}</span>
            </div>
          </div>
          <div className='playcontrol mute'>
            <button aria-label='mute' onClick={onMute}><span className='icon'><i className={muteIcon}></i></span></button>
          </div>
          <div className={this.state.displayPlaylist ? 'playcontrol playlist visible' : 'playcontrol playlist'}>
            <button aria-label='display playlist' onClick={(e) => { this.togglePlaylist() }}><span className='icon'><i className={playlistIcon}></i></span></button>
          </div>
        </div>
        <Playlists
          mini={true}
          debug={debug}
          className={this.state.displayPlaylist ? 'miniplaylist visible' : 'miniplaylist'} />
      </div>
    )
  }
}

Controls.defaultProps = {
  mini: false,
  playlist: 0,
  track: 0,
  debug: false,
  autoplay: false
}

Controls.propTypes = {
  debug: PropTypes.bool,
  autoplay: PropTypes.bool,
  className: PropTypes.string,
  mini: PropTypes.bool,
  playback: PropTypes.number.isRequired,
  track: PropTypes.number,
  tracks: PropTypes.array,
  playlist: PropTypes.number,
  playlists: PropTypes.array,
  total: PropTypes.number,
  mute: PropTypes.bool,
  progress: PropTypes.number,
  currentTime: PropTypes.number,
  duration: PropTypes.number,
  scrubbing: PropTypes.bool,
  onPlayPause: PropTypes.func,
  onPlayNext: PropTypes.func,
  onSetProgress: PropTypes.func,
  onPlayNextPlaylist: PropTypes.func,
  onSetCurrentTime: PropTypes.func,
  onMute: PropTypes.func,
  scrubbingOn: PropTypes.func,
  scrubbingOff: PropTypes.func
}
